import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class DashboardService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getDashboardUm(parameters) {
        return this.http.post(`${SCAMP_API.accountApiV1}/dashboard-um`, parameters, { headers: this.account.composeHeaders() });
    }
    getQuantitativoServicos(ano) {
        return this.http.get(`${SCAMP_API.accountApiV1}/quantitativo-servicos/${ano}`, { headers: this.account.composeHeaders() });
    }
    exportarQuantitativoServicosToExcel(ano) {
        return this.http.get(`${SCAMP_API.accountApiV1}/quantitativo-servicos/excel/${ano}`, { headers: this.account.composeHeaders() });
    }
}
DashboardService.ngInjectableDef = i0.defineInjectable({ factory: function DashboardService_Factory() { return new DashboardService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: DashboardService, providedIn: "root" });
